import { throttle } from 'lodash';
import checkHeader from './_checkHeader'

export default function () {
  const thisCheckHeader = checkHeader.bind(this);
  thisCheckHeader();
  this.scrollbar.addListener(throttle(thisCheckHeader,200));
}
